export const LOCAL_STORAGE_KEYS = {
  WOO_JWT: 'WooJWT',
  COMPLETED_STEPS: 'completedSteps',
  LAST_QUERY: 'lastQuery',
  ON_SCREEN_TUTORIAL_PASSED: 'onScreenTutorialPassed',
  HANDS: 'hands',
  SUBTITLES_ON: 'subtitlesOn',
  PLAYBACK_RATE_ON: 'playbackRateOn',
  PLAYBACK_RATE: 'playbackRate',
  DEV_MODE: 'devMode',
  NEW_VIDEO_SOURCE: 'newVideoSource',
};

export const COLORS = {
  lightBlue: '#E5E5E5',
};

export const LINKS = {
  SHOPIFY_KITS: 'https://thewoobles.com/collections/crochet-amigurumi-kits',
};

export const HANDS = {
  RIGHT: 'right',
  LEFT: 'left',
};

export const CHARACTER_LIMITS = {
  LARGE_TEXT: 80,
  SMALL_TEXT: 600,
};

export const OVERLAY_SIZE = {
  L: 'Large',
  M: 'Medium',
  S: 'Small',
};

export const PASSCODE_RESPONSES = {
  // eslint-disable-next-line
  BAD_REG_CODE: "Hm, we don't recognize that. Doublecheck any U's and V's, or 8's and B's and try again.",
  // eslint-disable-next-line
  LOCKED_CODE: "This code's been locked. Reach out to help@thewoobles.com with your email and order number for help.",
  WRONG_KIT:
    // eslint-disable-next-line
    "It looks like you've typed in a code for another kit, please make sure the card you have matches the Wooble on this page.",
};

export const GUIDES = {
  STEVE_THE_FRANKENSTEIN: {
    id: 'recx2QtYcBRnqcZP0',
  },
}; 

// These are added by default to all guides - once this is deployed
// we can remove from Airtable
export const DEFAULT_HELP_TOPICS = {
  HOW_DO_I_START_OVER: {
    id: 'recimOnVtJwHODroZ',
    display_name: 'How do I start over?',
    multiTopic: true,
    topics: [
      {
        id: 'rect1bykuTyqM2JbK',
        display_name: 'I want to get back to the starter piece',
        microsteps: [
          {
            id: 'recgvde4Somj37C6A',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec1XuJWaJL5iUbfH',
                url: '/videos/microsteps/---get-back-to-the-starter-piece-1.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---get-back-to-the-starter-piece-1.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recx5gZvRtsEta036',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec7YucHwwp1Q5nns',
                url: '/videos/microsteps/---get-back-to-the-starter-piece-2.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---get-back-to-the-starter-piece-2.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
        ],
      },
      {
        id: 'recMmtXN8MlS8WVKU',
        display_name: 'I want to put the stitch markers back in the starter piece',
        microsteps: [
          {
            id: 'recfbwVsJ6Gjg0xWZ',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recLtwH4lxPnak3gE',
                url: '/videos/microsteps/--put-stitch-markers-back-1.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--put-stitch-markers-back-1.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recgZP8JrBeKh3CZo',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recG0sdpZuNF5LzCx',
                url: '/videos/microsteps/--put-stitch-markers-back-2.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--put-stitch-markers-back-2.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recXl6zktP592yewG',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recFQQId2wa4gaYuj',
                url: '/videos/microsteps/--put-stitch-markers-back-3.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--put-stitch-markers-back-3.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
        ],
      },
      {
        id: 'recFTCRB3PcJquarH',
        display_name: 'I want to make the loop for the hook bigger or smaller',
        microsteps: [
          {
            id: 'reciNdfmkBRTXmXrZ',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recaIRzAIzpEX8M8C',
                url: '/videos/microsteps/--make-the-hook-loop-bigger-or-smaller-1.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-the-hook-loop-bigger-or-smaller-1.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recfBajK90ydE2dSw',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec5TYwYZhInIt7bR',
                url: '/videos/microsteps/--make-the-hook-loop-bigger-or-smaller-2.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-the-hook-loop-bigger-or-smaller-2.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'reccoG5s9rDIN7mEb',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec9LX2Pq2LnzKZgS',
                url: '/videos/microsteps/--make-the-hook-loop-bigger-or-smaller-3.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-the-hook-loop-bigger-or-smaller-3.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
        ],
      },
      {
        id: 'recE1iJpF43Agkz4m',
        display_name: 'I want to add a stitch to the starter piece',
        microsteps: [
          {
            id: 'recxPdXAkgwfo2mbc',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recrnB1X2Jx3JAiAW',
                url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-1.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-1.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'rec64tuGabFMZdARt',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec5dt0QlokFpgRTL',
                url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-2.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-2.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recuqflaJPymIFYY9',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recw0hpsfcDtMQHhV',
                url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-3.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-3.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recvLV2AJdUokNTi1',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recHC9M8Z2TWJMjFo',
                url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-4.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-4.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recy5RJl7l52Kh3Bz',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recZ06P8LeKhg1rTV',
                url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-5.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-5.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'receWAvH5CiUYN9Jt',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recH35g0e5APZ1YpG',
                url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-6.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--add-a-stitch-to-the-starter-piece-6.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
        ],
      },
      {
        id: 'recHegApVFdqYIZHw',
        display_name: 'I want to remove a stitch from the starter piece',
        microsteps: [
          {
            id: 'recaoFuw7ih9yUvZB',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recBzsOSzbrodvLDo',
                url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-1.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-1.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recYtRgFK1E68yUBN',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recSrWKfqBCMPqHvC',
                url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-2.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-2.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'rec7IxN6KWRbXD6JJ',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec35yktZ1y3dw0cR',
                url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-3.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-3.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recC0qF7Xxz7MH2v0',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec0uCrN99bsJpfLS',
                url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-4.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--remove-a-stitch-from-the-starter-piece-4.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
        ],
      },
      {
        id: 'receEwmoPZmSLsWoB',
        display_name: 'I want to make the starter piece',
        microsteps: [
          {
            id: 'rec1pss0BTUjW56gl',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec28PD1MqanJPb5u',
                url: '/videos/microsteps/---make-the-starter-piece-1.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---make-the-starter-piece-1.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recGoRBgkKL3Jc63F',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'reciFWaJpfdfr6mhU',
                url: '/videos/microsteps/---make-the-starter-piece-2.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---make-the-starter-piece-2.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recWA3hZLktrzxktE',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recjsh5V4rikGVbVe',
                url: '/videos/microsteps/---make-the-starter-piece-3.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---make-the-starter-piece-3.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recsYqpCHcyckMFuf',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recjzp0UlfjxvMQPb',
                url: '/videos/microsteps/---make-the-starter-piece-4.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---make-the-starter-piece-4.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'rec6d5oQE8ZfOv8Hh',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recK7l8gxikYyceYr',
                url: '/videos/microsteps/---make-the-starter-piece-5.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---make-the-starter-piece-5.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recFrZSIAPfFWsGLe',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec9p52ZjG9ecTeq8',
                url: '/videos/microsteps/---make-the-starter-piece-6.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---make-the-starter-piece-6.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recIfvcoZs1zbMfSy',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recdHQ4E4TJqsAPsj',
                url: '/videos/microsteps/---make-the-starter-piece-7.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/---make-the-starter-piece-7.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
        ],
      },
      {
        id: 'recUGUiUkSVIq7Cow',
        display_name: 'I want to make the starter piece with a magic loop',
        microsteps: [
          {
            id: 'recjYM1rprTSJe1mn',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recIGvyIgPcDGMiHb',
                url: '/videos/microsteps/--make-a-magic-loop-1.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-1.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recDnXLz1j2VfV8OW',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recmHg2imIgE0sy3D',
                url: '/videos/microsteps/--make-a-magic-loop-2.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-2.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recjybNpdSHzSXjlO',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'rec50sJ7RulUPsikG',
                url: '/videos/microsteps/--make-a-magic-loop-3.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-3.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recZ1LpPv9LIK7xXh',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recrHK0H7JjHFnBhW',
                url: '/videos/microsteps/--make-a-magic-loop-4.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-4.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'rec2SbRTzCKOEwaVH',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recfrScuOEXhOkBes',
                url: '/videos/microsteps/--make-a-magic-loop-5.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-5.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recF1lDXRrTDDncWH',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recVf5syY1fgff8qN',
                url: '/videos/microsteps/--make-a-magic-loop-6.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-6.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'rectk2SdxSt0IxYsm',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recdPHwSZkg3YHtyp',
                url: '/videos/microsteps/--make-a-magic-loop-7.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-7.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recnfCQZOv2bSEFva',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recjocvmGCqCY5lKk',
                url: '/videos/microsteps/--make-a-magic-loop-8.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-8.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'rec96Oeejs9gOumky',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recCKFTszzqk1XINS',
                url: '/videos/microsteps/--make-a-magic-loop-9.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-9.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recy8TbZpcJMweAX2',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recwBApjm4vYLhqMX',
                url: '/videos/microsteps/--make-a-magic-loop-10.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-10.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recaiJQroHOYwcTCZ',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recJAA0yVVx1ubGMh',
                url: '/videos/microsteps/--make-a-magic-loop-11.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-11.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
          {
            id: 'recyb3ZghmPrUz6p2',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [
              {
                id: 'recHKYUHk9VOQmN0Z',
                url: '/videos/microsteps/--make-a-magic-loop-12.mp4',
                lefty: false,
                add_background_music: false,
                subtitles: [
                  {
                    lang: 'en',
                    label: 'English',
                    url: '/videos/microsteps/--make-a-magic-loop-12.vtt',
                  },
                ],
              },
            ],
            overlays: [],
          },
        ],
      },
    ],
  },
  I_NEED_HELP_WITH_SOMETHING_ELSE: {
    id: 'recVDFgNhJnMLtDYa',
    display_name: 'I need help with something else',
    multiTopic: true,
    topics: [
      {
        isContactForm: true,
        display_name: 'Contact us',
      },
      {
        id: 'recjtsloYqoE0naaq',
        display_name: 'Get help from other Wooblers',
        url: 'https://www.facebook.com/groups/beginnercrocheters',
        icon: 'mdi-emoticon-happy-outline',
        microsteps: [
          {
            id: 'recXxbzFVdj5DmONU',
            display_name: ' - ',
            slug: '___',
            help_groups: [],
            videos: [],
            overlays: [],
          },
        ],
      },
    ],
  },
};
